export default __webpack_public_path__ + "static/media/level_active.4d618fe9.svg";